import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { captureUtmParamsFromSearch } from '../utils/utmStorage';

/**
 * Watches the URL for utm_* query params on ANY route (ad-campaign landings)
 * and persists them to sessionStorage. Same problem ReferralCapture solves
 * for ?ref= codes: a visitor who lands via an ad link, browses around, and
 * then registers from /register would otherwise lose the campaign
 * attribution on the signup-complete event.
 *
 * Session-scoped (sessionStorage, not localStorage) on purpose — an ad click
 * opens a new tab session, and a week-old UTM should not silently
 * re-attribute a user's later organic return. Last-touch wins within the
 * session, matching how the ad platforms report.
 *
 * Must be rendered inside <Router> (uses useLocation). Renders nothing.
 */
function UtmCapture() {
  const { search } = useLocation();

  useEffect(() => {
    captureUtmParamsFromSearch(search);
  }, [search]);

  return null;
}

export default UtmCapture;
